import { useTranslation } from "react-i18next";

import { useGetInventoryBoxQr } from "../../../../inventory/apis";
import { OrderBoxCellProps } from "../DamagedItemsTable.types";

const OrderBoxCell = ({ orderId, boxId }: OrderBoxCellProps) => {
  const { t } = useTranslation();
  const { boxItem } = useGetInventoryBoxQr(boxId);

  return (
    <>
      {orderId
        ? `${t("Order")} ${orderId}`
        : boxId
          ? `${t("Box")} ${boxItem?.name}`
          : "-"}
    </>
  );
};

export default OrderBoxCell;
